import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { TableComponent } from '../../../shared/table/table.component';
import { ReleaseNotesVm } from '../../../shared/generated/Models/ReleaseNotesVm';

@Component({
    selector: 'pcg-web-release-notes',
    templateUrl: './web-release-notes.component.html',
    styleUrls: ['./web-release-notes.component.scss'],
    standalone: false,
})
export class WebReleaseNotesComponent implements OnInit {
    // Get table reference from the page
    @ViewChild(TableComponent, { static: true })
    table: TableComponent<ReleaseNotesVm>;
    columns = ReleaseNotesVm.ColumnDefs;

    constructor(public title: Title) {}

    ngOnInit() {
        this.title.setTitle('Web Release Notes');
    }
}
